import { IntegrationPartner } from "refsix-js-models";
import { routes } from "../../route/constants";

/**
 * Where a scraped platform's page lives (REFSIX-568).
 *
 * Each platform has its own page and its own URL — `/integrations/moas`, as
 * `/integrations/assignr` does — so the catalogue-driven tiles need this to get
 * from an id to a route. The pages are hand-written rather than generated, so
 * this is the one place the two lists meet, and its unit test fails if a
 * catalogue entry has no page.
 */
const PLATFORM_ROUTES: Partial<Record<IntegrationPartner, string>> = {
    [IntegrationPartner.arbiter]: routes.refsixArbiterIntegration,
    [IntegrationPartner.moas]: routes.refsixMoasIntegration,
};

export function assignmentPlatformRoute(
    id: IntegrationPartner
): string | undefined {
    return PLATFORM_ROUTES[id];
}
